import { TextComponentConfig } from '../text/text-component-config.interface';

export interface ProductFeatureItem {
  feature: TextComponentConfig;
  detail: TextComponentConfig;
}
